// Adjustable bases + SmartLife sleep system. Per-size list pricing researched from authorized dealers (Bed Planet, Sit 'n Sleep, Mattress Warehouse, Mattress Plus).
const IMG = "/products/adjustable/";

const v = (obj) => Object.fromEntries(Object.entries(obj).map(([k, price]) => [k, { price, compareAt: null }]));

export const ADJUSTABLE_CATALOG = [
  {
    slug: "beautyrest-black-luxury-adjustable-base",
    name: "Beautyrest Black Luxury Adjustable Base",
    brand: "beautyrest-black",
    category: "adjustable-bases",
    price: 1899.99,
    compareAt: null,
    priceFrom: true,
    sku: "700813327",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: "New 2026",
    sizes: ["Twin XL", "Full", "Queen", "Split-Head Queen", "King", "Split-Head King", "California King", "Split-Head California King", "Split King", "Split California King"],
    variants: v({
      "Twin XL": 1899.99,
      Full: 1999.99,
      Queen: 1999.99,
      "Split-Head Queen": 2599.99,
      King: 2699.99,
      "Split-Head King": 3299.99,
      "California King": 2699.99,
      "Split-Head California King": 3299.99,
      "Split King": 3799.98,
      "Split California King": 3799.98,
    }),
    image: IMG + "brb-luxury-base-lifestyle.jpg",
    gallery: [
      IMG + "brb-luxury-base-lifestyle-sq.jpg",
      IMG + "brb-luxury-base-split-head.jpg",
      IMG + "brb-luxury-base-silo.jpg",
      IMG + "brb-luxury-base-features.jpg",
      IMG + "brb-luxury-base-remote.jpg",
    ],
    description:
      "The redesigned 2026 Beautyrest Black Luxury Adjustable Base is the first base with Dual Action Back and Lumbar Support, plus the Transition to Sleep system with gentle rocking and sound therapy, surround acoustic massage and four-color ambient underbed lighting. Available in standard, split-head and split-king sizes at MattressTown with local delivery and set-up.",
    features: [
      "Dual Action Back & Lumbar Support",
      "Transition to Sleep rocking + sound therapy",
      "Surround acoustic massage",
      "Wireless touchscreen remote (USB-C rechargeable)",
      "4-color ambient underbed lighting",
      "Bluetooth speakers + USB-A & USB-C charging",
      "3, 6 or 9 inch legs - zero-clearance compatible",
      "950 lb weight capacity, 20-year limited warranty",
    ],
  },
  {
    slug: "king-koil-dualflex-split-top-adjustable-base",
    name: "King Koil DualFlex Split Top Adjustable Base",
    brand: "king-koil",
    category: "adjustable-bases",
    price: 1799.99,
    compareAt: null,
    priceFrom: true,
    sku: "",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: null,
    sizes: ["Split-Head Queen", "Split-Head King"],
    variants: v({ "Split-Head Queen": 1799.99, "Split-Head King": 1999.99 }),
    image: IMG + "kk-dualflex-base-card.jpg",
    gallery: [IMG + "kk-dualflex-base-side.jpg", IMG + "kk-dualflex-lifestyle.jpg", IMG + "kk-dualflex-base-angle.jpg"],
    description:
      "King Koil by Reverie's Split Top base powers DualFlex split-head mattresses, so each sleeper can raise their own side of the head while sharing one bed. A whisper-quiet lift system, Bluetooth Nightstand app control and a wireless remote with three programmable positions make every night personal.",
    features: [
      "Independent split head + single foot",
      "Whisper-quiet lift system",
      "Bluetooth Nightstand app control",
      "Wireless remote, 3 programmable positions",
      "Anti-Snore & Zero Gravity presets",
      "LED night light",
      "3-in-1 legs (12\", 7\" or 5\") - zero clearance",
      "850 lb weight capacity, 20-year limited warranty",
    ],
  },
  {
    slug: "smartlife-adjustable-base",
    name: "SmartLife Adjustable Base by King Koil",
    brand: "smartlife",
    category: "adjustable-bases",
    price: 1999.99,
    compareAt: null,
    priceFrom: true,
    sku: "",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: null,
    sizes: ["Twin XL", "Queen", "Split-Head King", "Split-Head California King", "Split King", "Split California King"],
    variants: v({
      "Twin XL": 1999.99,
      Queen: 2369.99,
      "Split-Head King": 3399.98,
      "Split-Head California King": 3399.98,
      "Split King": 3999.98,
      "Split California King": 3999.98,
    }),
    image: IMG + "smartlife-base-card.jpg",
    gallery: [IMG + "smartlife-base-rails.jpg", IMG + "smartlife-base-no-rails.jpg"],
    description:
      "Built to pair with SmartLife body-sensing mattresses, the SmartLife Adjustable Base runs on two German-engineered OKIN motors with up to 1,320 lbs of lift capacity. The rail-free design drops into most headboard and footboard beds, and split configurations let each partner set their own position.",
    features: [
      "Dual German-engineered OKIN motors",
      "1,320 lb lift capacity",
      "Fits most headboard/footboard beds (no side rails)",
      "Head & foot articulation with zero gravity",
      "Wireless remote",
      "Split-head and split-king options",
    ],
  },
  {
    slug: "smartlife-adjustable-sleep-system",
    name: "SmartLife Adjustable Sleep System (Mattress + Base)",
    brand: "smartlife",
    category: "adjustable-bases",
    price: 8248,
    compareAt: null,
    priceFrom: true,
    sku: "",
    firmness: "Dual Adjustable",
    height: "-",
    type: "Sleep System",
    badge: "Set",
    sizes: ["Queen", "King", "Split-Head King"],
    variants: v({ Queen: 8248, King: 10498, "Split-Head King": 11398 }),
    image: IMG + "smartlife-system-lifestyle.jpg",
    gallery: [
      IMG + "smartlife-system-lifestyle-sq.jpg",
      IMG + "smartlife-system-dualflex.jpg",
      IMG + "smartlife-system-personalized.jpg",
      IMG + "smartlife-system-room.jpg",
    ],
    description:
      "The complete SmartLife by King Koil motion set: a SmartLife body-sensing mattress paired with its adjustable base. Patented sensing technology personalizes firmness for each side of the bed, DualFlex lets each sleeper raise their own head section, and sleep tracking helps you wake up better rested.",
    features: [
      "SmartLife mattress + adjustable motion base",
      "Body-sensing, auto-adjusting support",
      "Individual firmness control for each side",
      "DualFlex independent head adjustment",
      "Sleep tracking & insights",
    ],
  },
  {
    slug: "beautyrest-baselogic-bronze-adjustable-base",
    name: "Beautyrest baselogic Bronze Adjustable Base",
    brand: "beautyrest",
    category: "adjustable-bases",
    price: 579,
    compareAt: null,
    priceFrom: true,
    sku: "500833019",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: null,
    sizes: ["Twin XL", "Full", "Queen", "King", "Split California King"],
    variants: v({ "Twin XL": 579, Full: 599, Queen: 599, King: 899, "Split California King": 1158 }),
    image: IMG + "bronze-card.jpg",
    gallery: [IMG + "bronze-1.jpg", IMG + "bronze-2.jpg", IMG + "bronze-3.jpg", IMG + "bronze-4.jpg", IMG + "bronze-5.jpg"],
    description:
      "The baselogic Bronze is the easiest way into adjustable comfort: raise the head of your bed for reading, TV or easier breathing, then lower it flat with a simple wired remote. Removable 9-inch legs allow a zero-clearance profile, and the foldable frame makes moving day simple.",
    features: ["Head adjustability", "Wired remote", "Removable 9\" legs - zero-clearance compatible", "Foldable design for easy moving", "Compatible with Beautyrest mattresses"],
  },
  {
    slug: "serta-baselogic-silver-adjustable-base",
    name: "Serta baselogic Silver Adjustable Base",
    brand: "serta",
    category: "adjustable-bases",
    price: 849,
    compareAt: null,
    priceFrom: true,
    sku: "500833419",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: null,
    sizes: ["Twin", "Twin XL", "Full", "Queen", "King", "Split California King"],
    variants: v({ Twin: 849, "Twin XL": 849, Full: 899, Queen: 899, King: 1299, "Split California King": 1698 }),
    image: IMG + "silver-card.jpg",
    gallery: [IMG + "silver-1.jpg", IMG + "silver-2.jpg", IMG + "silver-3.jpg", IMG + "silver-4.jpg", IMG + "silver-5.jpg"],
    description:
      "The baselogic Silver adds head and foot adjustability, a one-touch zero-gravity preset and a wireless remote. 3-in-1 adjustable legs set your bed height up to 12 inches, or remove them for a zero-clearance profile inside your existing bed frame.",
    features: ["Head & foot adjustability", "One-touch zero-gravity preset", "One-touch flat preset", "Wireless remote", "3-in-1 legs - up to 12\" bed height", "Zero-clearance compatible"],
  },
  {
    slug: "beautyrest-baselogic-pearl-adjustable-base",
    name: "Beautyrest baselogic Pearl Adjustable Base",
    brand: "beautyrest",
    category: "adjustable-bases",
    price: 1499,
    compareAt: null,
    priceFrom: true,
    sku: "500837519",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: "New",
    sizes: ["Twin XL", "Full", "Queen", "King", "California King"],
    variants: v({ "Twin XL": 1499, Full: 1599, Queen: 1599, King: 1999, "California King": 1999 }),
    image: IMG + "pearl-card.jpg",
    gallery: [IMG + "pearl-1.jpg", IMG + "pearl-2.jpg", IMG + "pearl-3.jpg", IMG + "pearl-4.jpg", IMG + "pearl-5.jpg", IMG + "pearl-6.jpg"],
    description:
      "The baselogic Pearl adds an adjustable lumbar support bar that improves lower back support by up to 40%, plus head and foot adjustability, a whisper-quiet massage, underbed lighting and USB-A & USB-C charging.",
    features: ["Adjustable lumbar support bar", "Head & foot adjustability", "Single-zone massage", "Underbed lighting", "Zero-gravity & flat presets", "USB-A & USB-C charging ports", "Wireless remote", "Zero-clearance compatible"],
  },
  {
    slug: "mlily-ms100-adjustable-base",
    name: "MLILY MS100 Adjustable Base",
    brand: "mlily",
    category: "adjustable-bases",
    price: 799,
    compareAt: null,
    priceFrom: true,
    sku: "",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: null,
    sizes: ["Twin XL", "Full", "Queen", "King", "California King"],
    variants: v({ "Twin XL": 799, Full: 999, Queen: 1099, King: 1199, "California King": 1199 }),
    image: IMG + "ms100-card.jpg",
    gallery: [IMG + "ms100-1.jpg", IMG + "ms100-2.jpg", IMG + "ms100-3.jpg", IMG + "ms100-4.jpg"],
    description:
      "The MLILY MS100 is your key to elevated sleep. A wireless remote customizes the head and foot incline for reading, watching TV or unwinding, on a lightweight yet strong grid platform that assembles in about five minutes - no tools needed.",
    features: ["Wireless remote", "Head & foot adjustment", "Lightweight, strong grid platform", "Tool-free assembly in about 5 minutes"],
  },
  {
    slug: "mlily-ms200-adjustable-base",
    name: "MLILY MS200 Adjustable Base",
    brand: "mlily",
    category: "adjustable-bases",
    price: 1199,
    compareAt: null,
    priceFrom: true,
    sku: "",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: null,
    sizes: ["Twin", "Twin XL", "Full", "Queen", "King", "California King"],
    variants: v({ Twin: 1199, "Twin XL": 1199, Full: 1299, Queen: 1399, King: 1599, "California King": 1599 }),
    image: IMG + "ms200-card.jpg",
    gallery: [IMG + "ms200-1.jpg", IMG + "ms200-2.jpg", IMG + "ms200-3.jpg", IMG + "ms200-4.jpg"],
    description:
      "Improve your sleep quality with the MLILY MS200. Adjust the head and foot with a wireless remote, and use intelligent presets - including an anti-snore height - to breathe better and sleep deeper.",
    features: ["Wireless remote", "Head & foot adjustment", "Intelligent presets incl. anti-snore", "Tool-free assembly in about 5 minutes"],
  },
  {
    slug: "mlily-ms300-adjustable-base",
    name: "MLILY MS300 Adjustable Base",
    brand: "mlily",
    category: "adjustable-bases",
    price: 1499,
    compareAt: null,
    priceFrom: true,
    sku: "",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: null,
    sizes: ["Twin XL", "Full", "Queen", "King", "California King", "Split-Head King"],
    variants: v({ "Twin XL": 1499, Full: 1599, Queen: 1799, King: 1999, "California King": 1999, "Split-Head King": 2099 }),
    image: IMG + "ms300-card.jpg",
    gallery: [IMG + "ms300-1.jpg", IMG + "ms300-2.jpg", IMG + "ms300-3.jpg", IMG + "ms300-4.jpg"],
    description:
      "The MLILY MS300 brings a tailored sleep experience: personalized head and foot positioning, programmable presets and an advanced massage with three targeted modes and intensity levels, all from a wireless remote.",
    features: ["Massage - 3 modes & intensity levels", "Head & foot adjustment", "Programmable presets", "Wireless remote", "Tool-free assembly in about 5 minutes"],
  },
  {
    slug: "mlily-ms600-adjustable-base",
    name: "MLILY MS600 Adjustable Base",
    brand: "mlily",
    category: "adjustable-bases",
    price: 2099,
    compareAt: null,
    priceFrom: true,
    sku: "",
    firmness: "-",
    height: "-",
    type: "Adjustable Base",
    badge: null,
    sizes: ["Twin XL", "Queen"],
    variants: v({ "Twin XL": 2099, Queen: 2399 }),
    image: IMG + "ms600-card.jpg",
    gallery: [IMG + "ms600-1.jpg", IMG + "ms600-2.jpg", IMG + "ms600-3.jpg"],
    description:
      "MLILY's top-of-the-line MS600 features Tri-Zone Massage - on-bar lumbar massage plus head and foot massage - with lumbar adjustment and neck tilt for precision support, LED lighting and USB charging.",
    features: ["Tri-Zone massage - 3 modes, 3 intensities", "Lumbar adjustment & neck tilt", "Wireless remote", "USB charging ports", "LED lighting", "3-in-1 adjustable legs, no-tool setup"],
  },
  {
    slug: "mlily-powercool-sleep-system",
    name: "MLILY PowerCool Sleep System (Mattress + Base)",
    brand: "mlily",
    category: "adjustable-bases",
    price: 5198,
    compareAt: null,
    priceFrom: true,
    sku: "",
    firmness: "Firm or Medium",
    height: "-",
    type: "Sleep System",
    badge: "Set",
    sizes: ["Twin XL", "Queen", "King", "California King"],
    variants: v({ "Twin XL": 5198, Queen: 5998, King: 8897, "California King": 8897 }),
    image: IMG + "powercool-card.jpg",
    gallery: [IMG + "powercool-1.jpg", IMG + "powercool-2.jpg", IMG + "powercool-3.jpg", IMG + "powercool-4.jpg"],
    description:
      "The PowerCool Sleep System pairs a fully ventilated PowerCool mattress with the PowerCool Adjustable Base, whose integrated cooling fans actively circulate air through the mattress for next-level temperature control. Choose Firm or Medium feel.",
    features: ["Ventilated PowerCool mattress (Firm or Medium)", "Adjustable base with integrated cooling fans", "Head & foot adjustment", "Targeted airflow control", "Wireless remote"],
  },
];

export const FOUNDATIONS_CATALOG = [
  {
    slug: "serta-mattress-foundation",
    name: "Serta Mattress Foundation",
    brand: "serta",
    category: "foundations",
    price: 250,
    compareAt: null,
    priceFrom: true,
    sku: "500124899",
    firmness: "-",
    height: "9\" Standard or 5\" Low Profile",
    type: "Foundation",
    badge: null,
    sizes: ["Twin", "Twin XL", "Full", "Queen", "King", "California King"],
    variants: v({ Twin: 250, "Twin XL": 250, Full: 300, Queen: 300, King: 500, "California King": 500 }),
    image: IMG + "sertafound-card.jpg",
    gallery: [IMG + "sertafound-1.jpg", IMG + "sertafound-2.jpg", IMG + "sertafound-3.jpg", IMG + "sertafound-4.jpg"],
    description:
      "The Serta Mattress Foundation is a supportive box spring alternative that isolates movement and extends the life of your mattress. Available in standard and low-profile heights.",
    features: ["Box spring alternative", "Isolates motion", "Extends mattress life", "Standard 9\" or low-profile 5\""],
  },
  {
    slug: "beautyrest-flat-foundation",
    name: "Beautyrest Flat Foundation",
    brand: "beautyrest",
    category: "foundations",
    price: 180,
    compareAt: null,
    priceFrom: true,
    sku: "700812821",
    firmness: "-",
    height: "9\" Standard or 5.5\" Low Profile",
    type: "Foundation",
    badge: null,
    sizes: ["Twin", "Twin XL", "Full", "Queen", "King", "California King"],
    variants: v({ Twin: 180, "Twin XL": 180, Full: 220, Queen: 220, King: 360, "California King": 360 }),
    image: IMG + "brflat-card.jpg",
    gallery: [IMG + "brflat-1.jpg", IMG + "brflat-2.jpg", IMG + "brflat-3.jpg"],
    description:
      "The Beautyrest Flat Foundation is a box spring alternative designed for long-lasting comfort that enhances the support and motion separation of your Beautyrest mattress.",
    features: ["Box spring alternative", "Enhances support & motion separation", "Standard 9\" or low-profile 5.5\""],
  },
];
